module.exports = __webpack_public_path__ + "static/media/sort-down-active.a12a4679.svg";